import { FormControl, TextField, makeStyles } from "@material-ui/core";
import React from "react";

import "../styles/custom-text.css";

function CustomTextField(props) {
  const {
    id,
    labelVal,
    itemWidth = "100%",
    onChangeItem,
    onBlurItem,
    selectedValue,
    disabled,
    type = "text",
    errorValue = false,
    isLoginField = false,
    inputProps = {},
    helperText = "",
  } = props;

  const useStyles = makeStyles((theme) => ({
    root: {
      width: `${itemWidth} !important`,
    },
  }));
  const classes = useStyles();

  const getControlClasses = () => {
    if (errorValue) {
      if (isLoginField) {
        return "loginField customTextError";
      } else {
        return "customText customTextError";
      }
    } else {
      if (isLoginField) {
        return "loginField";
      } else {
        return "customText";
      }
    }
  };

  return (
    <div className={getControlClasses()}>
      <FormControl className={classes.root} variant="outlined">
        <TextField
          id={id}
          type={type}
          placeholder={labelVal}
          variant="outlined"
          value={selectedValue}
          onChange={onChangeItem}
          disabled={disabled}
          onBlur={onBlurItem}
          inputProps={inputProps}
          helperText={helperText}
        />
      </FormControl>
    </div>
  );
}

export default CustomTextField;
